//import french from './assets/statics/french.png'
import tunisia from './assets/statics/tunisia.png'
import morocco from './assets/statics/morocco.png'
const concours = [
    {
        name: "TUNISIE",
        link: "tunisie",
        image: tunisia
    },
    {
        name: "FRANCE",
        link: "france",
        image: "french"
    },
    {
        name: "MAROC",
        link: "maroc",
        image: morocco
    }
]
export default concours;